import { useEffect, useState } from 'react';

import { createRootElement } from '@r1-frontend/shared/helpers/dom';

export interface IUseRootElementProps {
    id: string,
    tag?: keyof HTMLElementTagNameMap,
}

/**
 * Coздает элемент в корне документа или возвращает
 * ссылку на него, если он существует
 */
export const useRootElement = ({ id, tag }: IUseRootElementProps) => {
    const [rootElement, setRootElement] = useState<HTMLElement | null>(null);

    useEffect(() => {
        if (rootElement) {
            return;
        }

        const element = createRootElement(id, tag);
        setRootElement(element);
    }, [id, tag, rootElement]);

    return rootElement;
};
